import React from 'react';

export default function LabeledText({ label, value }) {
  return (
    <p>
      <strong>{label}:</strong> {value || 'N/A'}
    </p>
  );
}